var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"star-rating"},_vm._l((_vm.stars),function(i,index){return _c('span',{key:index,class:(i == 1)
                    ? "fas fa-circle"
                    : (i == 0.5)
                        ? "fas fa-adjust"
                        : "far fa-circle"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }